import { Link, useNavigate } from "react-router-dom";
import { useLanguage } from "../context/LanguageContext";
import { getTranslation } from "../services/translations";
import "./Footer.css";

const Footer = () => {
  const { language } = useLanguage();
  const t = k => getTranslation(language, k);
  const navigate = useNavigate();

  const goSection = id => {
    navigate("/");
    setTimeout(() => {
      const el = document.getElementById(id);
      if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
    }, 150);
  };

  return (
    <footer className="footer">
      <div className="footer-grid">
        <div className="footer-brand footer-col">
          <div className="footer-logo-wrap">
            <div className="footer-logo-icon">
              <img src={`${process.env.PUBLIC_URL}/logo1.png`} alt="Logo" style={{width:"100%",height:"100%",objectFit:"contain"}}/>
            </div>
            <div className="logo-text-group">
              <span className="logo-main" style={{color:"#fff"}}>{t("footerBrandName")}</span>
              <span className="logo-sub" style={{color:"rgba(255,255,255,0.6)"}}>{t("footerBrandSub2")}</span>
            </div>
          </div>
          <p className="footer-tagline">{t("hospitalDescription")}</p>
          <div className="footer-contact-inline">
            <div className="footer-contact-item">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" width="13" height="13"><path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07A19.5 19.5 0 013.07 9.81a19.79 19.79 0 01-3.07-8.67A2 2 0 012 1h3a2 2 0 012 1.72c.127.96.361 1.903.7 2.81a2 2 0 01-.45 2.11L6.09 8.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0122 16.92z"/></svg>
              <span>+91 9996504991</span>
            </div>
            <div className="footer-contact-item">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" width="13" height="13"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/><polyline points="22,6 12,13 2,6"/></svg>
              <span>drashokgastrolivercentre@gmail.com</span>
            </div>
            <div className="footer-contact-item">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" width="13" height="13"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0118 0z"/><circle cx="12" cy="10" r="3"/></svg>
              <span>{t("footerCity")}</span>
            </div>
          </div>
        </div>
        <div className="footer-col">
          <h4>{t("quickLinks")}</h4>
          <ul className="footer-links">
            <li><button className="footer-link-btn" onClick={()=>goSection("home")}>{t("home")}</button></li>
            <li><Link to="/about" className="footer-link-a">{t("footerAboutUs")}</Link></li>
            <li><button className="footer-link-btn" onClick={()=>goSection("services")}>{t("services")}</button></li>
            <li><Link to="/team" className="footer-link-a">{t("teamLabel")}</Link></li>
            <li><button className="footer-link-btn" onClick={()=>goSection("facilities")}>{t("facilities")}</button></li>
            <li><button className="footer-link-btn" onClick={()=>goSection("contact")}>{t("contact")}</button></li>
          </ul>
        </div>
        <div className="footer-col">
          <h4>{t("followUs")}</h4>
          <div className="social-links">
            <a href="https://www.facebook.com/people/Ashok-Gastro-Liver-Centre/61569483430200/#" target="_blank" rel="noopener noreferrer" className="social-icon social-facebook" aria-label="Facebook">
              <svg viewBox="0 0 24 24" fill="currentColor" width="17" height="17"><path d="M18 2h-3a5 5 0 00-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 011-1h3z"/></svg>
            </a>
            <a href="https://www.instagram.com/dr.ashok.gastro/" target="_blank" rel="noopener noreferrer" className="social-icon social-instagram" aria-label="Instagram">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" width="17" height="17"><rect x="2" y="2" width="20" height="20" rx="5" ry="5"/><path d="M16 11.37A4 4 0 1112.63 8 4 4 0 0116 11.37z"/><line x1="17.5" y1="6.5" x2="17.51" y2="6.5"/></svg>
            </a>
            <a href="https://www.linkedin.com/in/dr-ashok-kumar-761733275/" target="_blank" rel="noopener noreferrer" className="social-icon social-linkedin" aria-label="LinkedIn">
              <svg viewBox="0 0 24 24" fill="currentColor" width="17" height="17"><path d="M16 8a6 6 0 016 6v7h-4v-7a2 2 0 00-2-2 2 2 0 00-2 2v7h-4v-7a6 6 0 016-6zM2 9h4v12H2z"/><circle cx="4" cy="4" r="2"/></svg>
            </a>
          </div>
        </div>
      </div>
      <div className="footer-bottom">
        <p className="footer-copyright">2025 Dr. Ashok Gastro and Liver Hospital. {t("allRightsReserved")}</p>
        <div className="footer-legal">
          <a href="#privacy">{t("privacyPolicy")}</a>
          <a href="#terms">{t("termsOfService")}</a>
          <a href="#disclaimer">{t("disclaimer")}</a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
